import { z } from 'zod';

// Shared password policy for any flow that accepts a new password
// (signup, password reset, etc.). Keep this as the single source of truth
// so the policy can't drift between forms.
export const passwordField = z.string()
    .min(8, 'Password must be at least 8 characters')
    .regex(/[A-Z]/, 'Password must include an uppercase letter')
    .regex(/[a-z]/, 'Password must include a lowercase letter')
    .regex(/\d/, 'Password must include a digit')
    .regex(/[^A-Za-z0-9]/, 'Password must include a special character');
